import React, { useEffect } from 'react';
import config from '../../config.json';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import styled from 'styled-components';
import { Button, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog, DialogContent, DialogActions, Grid, Autocomplete, TextField } from '@mui/material';
import Moment from 'moment';
import { getSChedule, getSiteData, getEmployee, searchSchedule, deleteSchedule } from '../../api';

const TableWrapper = styled.div`
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
         background-color: #F59300 !important;
    }
   
    .materialTableStyle {
        .filterAutocomplete{
    
            .closeIcon { 
                position: absolute;
                left: 450px;
                right: 0px;
                top: 20px;
                bottom: 0px;
            }
            .MuiFilledInput-root {
                background-color: #ffffff;
                border-radius: 0;
                height : 35px;
                padding-top : 0px;
            }
            .MuiFilledInput-input {
                padding: none;
                font-size: 12px;
                height : 10px;
            }
            .MuiFilledInput-underline:before {
                border: 0;
            }
            .MuiInputLabel-filled {
                transform: translate(12px,7px) scale(1);
                font-size: 12px;
            }
            .MuiFilledInput-underline:after {
                border: 0;
            }
            .MuiSelect-select:focus {
                background-color: #ffffff;
            }
            .MuiInputLabel-filled.MuiInputLabel-shrink {
                transform: translate(0px,-12px) scale(0.90) !important;
                color: #F59300;
            }}
        table {
            border-collapse: separate;
            border-spacing: 0 1em;
            width: 99%;
            margin: auto;
        }
        th:first-child, td:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        th:last-child, td:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
        th {
            font-size: 12px !important;
            white-space: nowrap;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            color: #F59300;
            height: 55px;
        }
        .MuiTableSortLabel-active {
            color: #F59300;
        }
        .MuiTableSortLabel-root:hover {
            color: #F59300;
        }
        .MuiTableSortLabel-icon {
            color: #F59300 !important;
        }
        td {
            position: relative;
            font-size: 12px !important;
            color: #000;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            height: 60px;
        }
        tbody {
            tr {
                position: relative;
                border-radius: 15px;
                transition: all 0.3s linear;
              
                &:hover {
                    box-shadow: 0 10px 6px rgba(0,0,0,0.10), 0 6px 3px rgba(0,0,0,0.10);

                    .actionListDeleteIconPosition {
                        display: block;
                    }
                    .actionListEditIconPosition {
                        display: block;
                    }
                    .actionListVisibilityIconPosition {
                        display: block;
                    }
                }
            }
        }
        .actionListDeleteIconPosition {
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListEditIconPosition {
            position: absolute;
            top: -16px;
            right: 56px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListVisibilityIconPosition {
            position: absolute;
            top: -16px;
            right: 101px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionBtn {
            padding: 8px;
            background-color: #ffffff;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

            &:hover {
                background-color: rgba(245,147,0,0.1);
                color: #F59300;
            }
        }
        .actionIcon {
            font-size: 17px;
        }
    }
    .filterRow {
        display: grid;
        grid-template-columns: 2fr 2fr 2fr 2fr 1fr 1fr;
        background-color: rgba(245, 147, 0, 0.1);
        height: 60px;
        border-radius: 15px;
        align-items: center;
        grid-column-gap: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 99%;
        margin: auto;
    }
    .filterIconSize{
        font-size: 18px;
    }
    .filterDropdown {
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
        }
        .MuiFilledInput-input {
            padding: 5px 10px 5px;
            font-size: 12px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }
       
    }
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headCells = [
    { id: 'scheduleinText', numeric: false, label: 'Schedule Description' },
    { id: 'siteName', numeric: false, label: 'Project Site Name' },
    { id: 'nextRunDate', numeric: false, label: 'Next Run Date' },
    { id: 'employeeName', numeric: false, label: 'User/Group Name' },
    { id: 'createdDate', numeric: false, label: 'Created Date' },
    { id: 'createdBy', numeric: false, label: 'Created By' }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function Scheduler() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    var [rows, setRows] = React.useState([]);
    var [filteredRows, setFilteredRows] = React.useState([]);
    var [search, setSearch] = React.useState("");
    var [disable, setDisable] = React.useState(true);
    const token = config.TOKEN
    const navigate = useNavigate();
    var [deletePopup, setDeletePopup] = React.useState(false);
    var [recordId, setRecordId] = React.useState();
    var [userEmail, setUserEmail] = React.useState("");
    var [userProfile, setUserProfile] = React.useState();
    const currentDate = Moment();
    var [weekDays, setWeekDays] = React.useState(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'])
    var [userData, setUserData] = React.useState([]);
    var [siteData, setSiteData] = React.useState([]);
    var [routeData, setRouteData] = React.useState([]);
    var [userId, setUserId] = React.useState(null);
    var [weekDay, setWeekDay] = React.useState('');
    var [siteId, setSiteId] = React.useState(null);
    const errorMessage = () => toast("An error occured,try again later", { progressClassName: classes.customToastProgress });
    const deleteMessage = () => toast("Schedule deleted successfully!", { progressClassName: classes.customToastProgress });
    const errorContactMessage = () => toast("An error occured, contact support", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        setUserProfile(userProfile);
        userEmail = userProfile.userEmail;
        setUserEmail(userEmail);
        getUserData();
        fetchSiteData();
        fetchSChedule();
    }, []);

    const fetchSChedule = async () => {
        try {
            const res = await getSChedule();
            if (res.data.successCode === 0) {
                rows = res.data.data.filter((row) => row.formType !== 'Training Form')
                setRows(rows);
                filteredRows = rows
                setFilteredRows(filteredRows);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const getUserData = async () => {
        try {
            const res = await getEmployee();
            if (res.data.successCode === 0) {
                userData = res.data.data
                setUserData(userData);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchSiteData = async () => {
        try {
            const res = await getSiteData(userEmail);
            if (res.data.successCode === 0) {
                siteData = res.data.data
                setSiteData(siteData);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const handleSearch = async () => {
        const postData = {
            "siteId": siteId,
            "userId": userId,
            "weekDay": weekDay
        }

        try {
            const res = await searchSchedule(postData);
            if (res.data.successCode === 0) {
                rows = res.data.data.filter((row) => row.formType !== 'Training Form')
                setRows(rows);
                filteredRows = rows
                setFilteredRows(filteredRows);
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const handleDeleteSchedule = async () => {
        try {
            const res = await deleteSchedule(recordId, userEmail);
            if (res.data.successCode === 0) {
                deleteMessage();
                fetchSChedule();
            } else {
                errorMessage();
            }
            setTimeout(() => { setDeletePopup(false) }, 3000)
        } catch (error) {
            errorMessage();
            setTimeout(() => { setDeletePopup(false) }, 3000)
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const updateUser = (row) => {
        navigate("/scheduler/edit/" + row.id)
    }

    const openDeletePopup = (id) => {
        recordId = id
        setRecordId(recordId);
        console.log(recordId);
        deletePopup = true
        setDeletePopup(deletePopup);
    }

    return (
        <>
            <TableWrapper>
                <ToastContainer theme='dark' />
                <Dialog open={deletePopup} closeonescape="true" maxWidth="true" >
                    <TableWrapper>
                        <DialogContent className="dialogStyle">
                            <div className={`${classes.root} materialTableStyle`}>
                                Do you want to delete the record?
                            </div>
                            <DialogActions>
                                <Grid container spacing={4} className="mt-1">
                                    <Grid item xs={12} sm={12} md={12} className="text-center">
                                        <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => setDeletePopup(false)}>
                                            No
                                        </Button>&nbsp;&nbsp;
                                        <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={() => handleDeleteSchedule()}>
                                            Yes
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogActions>
                        </DialogContent>
                    </TableWrapper>
                </Dialog>
                <div className={`${classes.root} materialTableStyle`}>
                    <div className="filterRow">
                        <Autocomplete
                            options={userData}
                            className="filterAutocomplete"
                            getOptionLabel={(option) => option.name}
                            onChange={(event, employee) => {
                                employee != null ? setUserId(employee.id) : setUserId(null);
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth label="Select User" variant="filled" />}
                        />
                        <Autocomplete
                            options={weekDays}
                            className="filterAutocomplete"
                            getOptionLabel={(option) => option}
                            onChange={(event, weekDay) => {
                                setWeekDay(weekDay);
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth label="Select Day" variant="filled" />}
                        />
                        <Autocomplete
                            options={siteData}
                            className="filterAutocomplete"
                            getOptionLabel={(option) => option.name || ""}
                            onChange={(event, site) => {
                                site != null ? setSiteId(site.id) : setSiteId(null);
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} fullWidth label="Select Site" variant="filled" />}
                        />
                        <span>
                            <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={handleSearch}>
                                Search
                            </Button>&nbsp;<Button variant="contained" color="primary" className="noShadow w-80 addBtn" onClick={() => navigate("/scheduler/add")}>
                                Add
                            </Button>
                        </span>
                    </div>
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {stableSort(filteredRows, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((filteredRows, index) => {
                                        filteredRows.nextRunDate = Moment(Date.parse(filteredRows.nextRunDate)).format('MM/DD/YYYY hh:mm A')
                                        filteredRows.createdDate = Moment(Date.parse(filteredRows.createdDate)).format('MM/DD/YYYY hh:mm A')
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={filteredRows.id}
                                            >
                                                <TableCell align="left">
                                                    {filteredRows.scheduleinText}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {filteredRows.siteName}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {filteredRows.nextRunDate}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {filteredRows.employeeName}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {filteredRows.createdDate}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {filteredRows.createdBy}
                                                    {filteredRows.formType !== 'Training Form' &&
                                                        <>
                                                            <div className="actionListEditIconPosition">
                                                                <Tooltip title="Edit" aria-label="edit">
                                                                    <IconButton className="actionBtn" aria-label="edit">
                                                                        <EditIcon className="actionIcon" onClick={() => { updateUser(filteredRows) }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                            <div className="actionListDeleteIconPosition">
                                                                <Tooltip title="delete" aria-label="delete">
                                                                    <IconButton className="actionBtn" aria-label="delete" onClick={() => openDeletePopup(filteredRows.id)}>
                                                                        <DeleteIcon className="actionIcon" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        </>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </TableWrapper>
        </>
    )
}
